import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, Invoice, InvoiceUpdateNotes } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateInvoiceNotes(): UseMutationResult<
  AxiosResponse<Invoice>,
  AxiosError<ErrorMessage>,
  InvoiceUpdateNotes
> {
  const queryClient = useQueryClient();

  const updateInvoiceNotes = (payload: InvoiceUpdateNotes): Promise<AxiosResponse<Invoice>> => {
    return client.put(`invoices/${payload?.invoiceId}/update-notes/`, payload);
  };

  return useMutation(updateInvoiceNotes, {
    onSuccess: () => {
      queryClient.invalidateQueries(['invoices']);
    },
  });
}
